import { formatFunc, parserFunc, keyBlock } from '../utils';
import { Row, Col, InputNumber, Modal, Form } from 'antd';
import { FormTitleDivider, ActionButtons } from 'common';
import { BInput } from 'common/components';
import React from 'react';

const Tabla1 = ({ Switch1, setSwitch1, form }) => {
  const changeSwitch = (value) => {
    const actions = {
      true: 'desactivar',
      false: 'activar',
    };
    const actions2 = {
      true: 'Desactivar',
      false: 'Activar',
    };
    const message = {
      default: `¿Está seguro que desea ${actions[value]} la tabla?`,
      representative: `¿Está seguro que desea ${actions[value]} la tabla?`,
    };
    Modal.confirm({
      title: `${actions2[value]} tabla`,
      content: (
        <>
          <p>{`${value === true ? message.representative : message.default}`} </p>
          {`Al realizar esta acción
          la tabla ${value === true ? 'no ' : ''}se visualizará en el acuerdo comercial`}
        </>
      ),
      onOk() {
        setSwitch1({
          checked: value,
          disabled: false,
        });
      },
    });
  };
  return (
    <div>
      <Row>
        <Col span={3}>
          <FormTitleDivider title={'Tabla 1'} />
        </Col>
        <Col span={2}>
          <h3
            style={{
              textAlign: 'left',
              fontSize: '14px',
              color: 'rgb(33,160,210)',
              fontWeight: '400',
              height: '25px',
            }}
          >
            {Switch1.checked === false ? '*' : ''}Título de tabla:
          </h3>
        </Col>
        <Col span={8}>
          <BInput
            className="form-add-user-input"
            name="nameOA"
            maxlength="50"
            disabled={Switch1.checked === true}
          />
        </Col>

        {/* SWITCH */}
        <Col span={6}>
          <ActionButtons
            disabled={true}
            statusChange={changeSwitch}
            statusSwitch={Switch1}
            buttons={[]}
          />
        </Col>
      </Row>

      {/* OBJETIVOS */}
      {/* 1 */}
      <Row>
        <Col span={8}>
          <Form.Item name="objective1" label={`${Switch1.checked === false ? '*' : ''}Objetivo 1:`}>
            <InputNumber
              style={{ border: '1px solid #d9d9d9' }}
              formatter={formatFunc}
              parser={parserFunc}
              max={999.99}
              maxLength={13}
              min={0}
              step="0.01"
              label="Precio neto"
              onKeyDown={keyBlock}
              disabled={Switch1.checked === true}
            />
          </Form.Item>
        </Col>

        {/* 2 */}
        <Col span={8}>
          <Form.Item name="objective2" label="Objetivo 2:">
            <InputNumber
              style={{ border: '1px solid #d9d9d9' }}
              formatter={formatFunc}
              parser={parserFunc}
              max={999.99}
              maxLength={12}
              min={0}
              step="0.01"
              label="Precio neto"
              stringMode
              onKeyDown={keyBlock}
              disabled={Switch1.checked === true}
            />
          </Form.Item>
        </Col>

        {/* 3 */}
        <Col span={8}>
          <Form.Item name="objective3" label="Objetivo 3:">
            <InputNumber
              style={{ border: '1px solid #d9d9d9' }}
              formatter={formatFunc}
              parser={parserFunc}
              max={999.99}
              maxLength={12}
              min={0}
              step="0.01"
              label="Precio bruto"
              stringMode
              onKeyDown={keyBlock}
              disabled={Switch1.checked === true}
            />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default Tabla1;
